import React from 'react';

interface DetailsPanelProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

const DetailsPanel: React.FC<DetailsPanelProps> = ({ title, onClose, children }) => {
  return (
    <div className="card details-panel">
      <div className="details-header">
        <h3>{title}</h3>
        <button onClick={onClose} className="close-btn">&times;</button>
      </div>
      <div className="details-content">
        {children}
      </div>
    </div>
  );
};

export default DetailsPanel;
